export const sliderData=[
    {
        img:"./images/alexander-kaunas-TAgGZWz6Qg8-unsplash.jpg",
        title:"Choose from a wide Range of Hotels"
    },
    {
        img:"./images/architecture-mansion-house-building-palace-city-893026-pxhere.com.jpg",
        title:"Be More than a Guest"
    },
    {
        img:"./images/lawrence-crayton-cf1cN3ofKUM-unsplash.jpg",
        title:"Book a Vacation with your Family"
    },
    {
        img:"./images/ralph-ravi-kayden-FqqiAvJejto-unsplash.jpg",
        title:"Exceptional Attention to Every Little Detail"
    },
    {
        img:"./images/vojtech-bruzek-Yrxr3bsPdS0-unsplash.jpg",
        title:"Cozy rooms and Apartments"
    }
]